/* CRO J1 Wave 3 (Nov 2026): buy box behaviour and plan-line cart rules. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  function track(name, data) {
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }

  /* ---------- Buy box ---------- */
  function initBox(bb) {
    if (bb.__cro) return; bb.__cro = 1;
    var info = bb.closest('product-info');
    if (!info) return;
    var sid = info.getAttribute('data-section-id'), pid = info.getAttribute('data-product-id');
    var formId = 'ProductForm-' + sid + '-' + pid;
    var form = document.getElementById(formId);
    var opts = Array.prototype.slice.call(bb.querySelectorAll('.cro-bb__opt'));
    var sum = bb.querySelector('.cro-bb__sum');
    var disc = bb.querySelector('.cro-bb__disc');
    var sel = bb.querySelector('.cro-bb__opt.is-on') || opts[0];

    function swatch(val) {
      return info.querySelector('variant-selects input[type="radio"][value="' + val.replace(/"/g, '\\"') + '"]');
    }
    /* Card images: reuse the theme's swatch image for each option. */
    opts.forEach(function (o) {
      var inp = swatch(o.getAttribute('data-opt'));
      var lab = inp && info.querySelector('label[for="' + inp.id + '"] img');
      var im = o.querySelector('.cro-bb__im');
      if (lab && im) { im.src = (lab.getAttribute('src') || '').replace(/width=\d+/, 'width=140'); im.hidden = false; }
      else o.classList.add('no-im');
    });

    function sticky() {
      var st = document.querySelector('#ProductStickyForm-' + sid + '-' + pid + ' [data-sticky-product-options]');
      if (st && sel) st.textContent = sel.getAttribute('data-st');
    }

    function paint() {
      opts.forEach(function (o) { var on = o === sel; o.classList.toggle('is-on', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var plan = !!(sel && sel.getAttribute('data-sp'));
      info.classList.toggle('cro-bb-sub', plan);
      if (sum) { sum.innerHTML = plan ? sel.getAttribute('data-sum') : ''; sum.hidden = !plan; }
      if (disc) {
        if (plan) {
          disc.textContent = sel.getAttribute('data-disc') + ' ';
          var a = document.createElement('a'); a.href = disc.getAttribute('data-terms'); a.textContent = 'Plan terms'; a.target = '_blank'; a.rel = 'noopener';
          disc.appendChild(a);
        }
        disc.hidden = !plan;
      }
      sticky();
    }

    function choose(o) {
      if (!o || o.classList.contains('is-off')) return;
      sel = o; paint();
      var inp = swatch(o.getAttribute('data-opt'));
      if (inp && !inp.checked) inp.click();
      track('cro_bb_select', { option: o.getAttribute('data-k') });
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () { choose(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); choose(o); }
      });
    });

    /* Keep the cards in step if the variant changes some other way (URL, back button, other UI). */
    function onVariant(v) {
      if (!v || !sel) return;
      if (sel.getAttribute('data-opt') === v.option1) { sticky(); return; }
      var match = bb.querySelector('.cro-bb__once .cro-bb__opt[data-opt="' + String(v.option1).replace(/"/g, '\\"') + '"]');
      if (match) { sel = match; paint(); }
    }
    if (form) form.addEventListener('variant:change', function (e) { onVariant(e.detail && e.detail.variant); });
    if (window.theme && theme.pubsub) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (e) {
        if (e && e.data && e.data.sectionId === sid) setTimeout(sticky, 60);
      });
    }

    /* Plan add: device and plan line in one cart add, then the theme's own cart refresh. */
    document.addEventListener('submit', function (e) {
      if (e.target !== form || !sel || !sel.getAttribute('data-sp')) return;
      if (document.body.classList.contains('template-cart') || (window.theme && theme.settings && theme.settings.cartType === 'page')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"]');
      if (btn && btn.getAttribute('aria-busy') === 'true') return;
      var buttons = document.querySelectorAll('[type="submit"][form="' + formId + '"]');
      var all = [btn].concat(Array.prototype.slice.call(buttons)).filter(Boolean);
      all.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.setAttribute('aria-busy', 'true'); });
      if (form.handleErrorMessage) form.handleErrorMessage();
      var fd = new FormData(form);
      var vid = parseInt(fd.get('id'), 10), qty = parseInt(fd.get('quantity') || '1', 10) || 1;
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
      sections = sections.filter(function (s, i) { return s && sections.indexOf(s) === i; });
      var body = {
        items: [
          { id: vid, quantity: qty },
          { id: parseInt(sel.getAttribute('data-vid'), 10), quantity: 1, selling_plan: parseInt(sel.getAttribute('data-sp'), 10), properties: { _cro_for: String(vid) } }
        ],
        sections: sections,
        sections_url: location.pathname
      };
      var planKey = sel.getAttribute('data-k');
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (form.handleErrorMessage) form.handleErrorMessage(res.description || res.message);
            if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: vid, errors: res.errors || res.description, message: res.message });
            return;
          }
          return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = res.sections;
            if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: vid, cart: cart });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res } }));
            track('cro_bb_plan_added', { plan: planKey, variant_id: vid });
            var drawer = document.querySelector('cart-drawer');
            if (drawer && drawer.show) drawer.show(btn); else location.href = ROOT + 'cart';
          });
        })
        .catch(function () { if (form.handleErrorMessage) form.handleErrorMessage('Something went wrong. Please try again.'); })
        .then(function () { all.forEach(function (b) { b.removeAttribute('aria-disabled'); b.removeAttribute('aria-busy'); }); });
    }, true);

    /* Stock line and guarantee sit under the button (and under the pay later line when it shows). */
    var wrap = form && (form.closest('.btn-atc') || form);
    if (wrap && wrap.parentElement) {
      var after = wrap;
      var nx = wrap.nextElementSibling;
      if (nx && nx.querySelector && nx.querySelector('.afterpay-paragraph')) after = nx;
      var inv = document.getElementById('Inventory-' + sid + '-' + pid);
      var guar = bb.querySelector('[data-cro-bb-guar]');
      [inv, guar].forEach(function (el) { if (el) { after.insertAdjacentElement('afterend', el); after = el; } });
    }

    paint();
  }

  /* ---------- Cart rules for plan lines ----------
     A plan line (property _cro_for = device variant id) stays at quantity 1
     and is removed when its device leaves the cart. */
  var fixing = false;
  function isPlan(it) {
    return it && it.properties && it.properties._cro_for;
  }
  function check(cart) {
    if (fixing || !cart || !cart.items) return;
    var have = {}, updates = {}, n = 0;
    cart.items.forEach(function (it) { if (!isPlan(it)) have[String(it.variant_id)] = 1; });
    cart.items.forEach(function (it) {
      if (!isPlan(it)) return;
      if (!have[String(it.properties._cro_for)]) { updates[it.key] = 0; n++; }
      else if (it.quantity > 1) { updates[it.key] = 1; n++; }
    });
    if (!n) return;
    fixing = true;
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    sections = sections.filter(function (s, i) { return s && sections.indexOf(s) === i; });
    fetch(ROOT + 'cart/update.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ updates: updates, sections: sections, sections_url: location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (window.theme && theme.pubsub && sections.length) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cro-bb', cart: c });
        else location.reload();
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { fixing = false; }, 300); });
  }
  function watchCart() {
    if (!(window.theme && theme.pubsub)) return;
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (!e || e.source === 'cro-bb') return;
      if (e.cart && e.cart.items) check(e.cart);
      else fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(check).catch(function () {});
    });
    if (document.querySelector('tr[id^="CartItem-"]')) {
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(check).catch(function () {});
    }
  }

  function place() {
    var tpl = document.getElementById('cro-bb-tpl');
    if (!tpl || !tpl.content) return;
    var root = tpl.content.querySelector('[data-cro-bb]');
    if (!root) return;
    var pid = root.getAttribute('data-product-id');
    var info = document.querySelector('product-info[data-section-id*="main-product"][data-product-id="' + pid + '"]') || document.querySelector('product-info[data-product-id="' + pid + '"]');
    var vs = info && info.querySelector('variant-selects');
    if (!vs || info.querySelector('[data-cro-bb]')) return;
    vs.insertAdjacentElement('afterend', document.importNode(root, true));
  }

  /* ---------- Cart line text for plan lines (drawer and cart page) ---------- */
  var PLANS = (window.CROBB && CROBB.plans) || {};
  function planOf(line) {
    var vid = line.getAttribute('data-variant-id');
    if (!vid) {
      var a = line.querySelector('a[href*="variant="]');
      var m = a && a.getAttribute('href').match(/variant=(\d+)/);
      vid = m && m[1];
    }
    return vid && PLANS[vid] ? PLANS[vid] : null;
  }
  function decorate() {
    document.querySelectorAll('li[id^="CartDrawer-Item-"], tr[id^="CartItem-"]').forEach(function (line) {
      var pl = planOf(line);
      if (!pl) return;
      line.classList.add('cro-plan-li');
      var txt = pl.y
        ? CROBB.zero + ' today. Then 4 ' + (pl.s ? 'cartridges' : 'filters') + ' every 12 months for ' + pl.p + ', free shipping.'
        : CROBB.zero + ' today. Then a new ' + (pl.s ? 'cartridge' : 'filter') + ' every 3 months for ' + pl.p + '.';
      var r = line.querySelector('.cro-renew');
      if (!r) {
        var dl = line.querySelector('dl');
        r = document.createElement('p');
        r.className = 'text-xs cro-renew';
        var host = dl ? dl.parentElement : (line.querySelector('.cro-li__meta') || {}).parentElement;
        if (!host) return;
        host.appendChild(r);
      }
      r.classList.add('cro-renew--plan');
      if (r.textContent !== txt) r.textContent = txt;
      var q = line.querySelector('.quantity__input');
      if (q) { q.readOnly = true; q.setAttribute('aria-readonly', 'true'); }
    });
  }
  function watchLines() {
    decorate();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(decorate, 30); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Login: guest checkout button reads as one action ---------- */
  function login() {
    var g = document.querySelector('input[name="form_type"][value="guest_login"]');
    if (!g) return;
    var box = g.form && g.form.parentElement;
    if (box) box.classList.add('cro-guest');
    var b = g.form.querySelector('button');
    var h = box && box.querySelector('h2');
    if (b && h) { b.textContent = h.textContent.trim(); h.innerHTML = '<span class="cro-or">or</span>'; }
  }

  /* ---------- Accordion titles: let a swipe on a title scroll the page ----------
     The accordion script fires a click on touchstart/pointerdown and cancels the gesture, so the page
     can't scroll from a title. Taps still open and close through the normal click. */
  function accordionScroll() {
    ['touchstart', 'pointerdown'].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (e.target && e.target.closest && e.target.closest('.js-accordionTrigger')) e.stopPropagation();
      }, { capture: true, passive: true });
    });
  }

  function boot() {
    place();
    document.querySelectorAll('[data-cro-bb]').forEach(initBox);
    watchCart();
    watchLines();
    login();
  }
  accordionScroll();
  if (document.readyState === 'complete') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();